/* eslint-disable no-unused-vars */
import debounce from './modules/debounce';
import ready from './modules/onReady';

// Import Bootstrap JavaScript plugins individually as needed to keep bundle sizes down
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';

import ExternalLinkInterstitialModal from './components/externalLinkInterstitialModal';
import HcpAttestationModal from './components/hcpAttestationModal';
import Publications from './components/publications';
import SearchResults from "./components/search-results";
import MSLConnect from "./components/msl-connect";
import PageSearchBar from "./components/page-search-bar";
import FeedbackModule from "./components/feedback-module";
import LandingPages from "./components/landing-pages";

/* eslint-enable no-unused-vars */

// get globally-declared variable(s) from WP
// const WP = window.mira_scripts_object;
// console.log('WP: ', WP);

// easy check, if mobile
const isMobile =
  window.matchMedia('(pointer:coarse)').matches ||
  window.matchMedia('(any-pointer:coarse)').matches;

let docWidth,
  wpAdminBar,
  wpAdminBarHeight,
  siteHeader,
  siteHeaderHeight,
  mobileGeoRestrictionBanner,
  mobileGeoRestrictionBannerHeight;

const updateCssVariables = () => {
  // update relevant widths
  docWidth = window.innerWidth;

  // update relevant heights
  wpAdminBarHeight = wpAdminBar ? wpAdminBar.offsetHeight : 0;
  siteHeaderHeight = Math.floor(siteHeader.getBoundingClientRect().height);
  mobileGeoRestrictionBannerHeight = mobileGeoRestrictionBanner
    ? mobileGeoRestrictionBanner.offsetHeight
    : 0;

  // now update any CSS variables...
  document.documentElement.style.setProperty(
    '--mira-window-width',
    `${docWidth}px`,
  );
  document.documentElement.style.setProperty(
    '--mira-window-height',
    `${window.innerHeight}px`,
  );
  document.documentElement.style.setProperty(
    '--mira-wp-admin-bar-height',
    `${wpAdminBarHeight}px`,
  );
  document.documentElement.style.setProperty(
    '--mira-site-header-height',
    `${siteHeaderHeight}px`,
  );
  document.documentElement.style.setProperty(
    '--mira-mobile-geo-restriction-banner-height',
    `${mobileGeoRestrictionBannerHeight}px`,
  );
};

// Handler when the DOM is fully loaded
ready(() => {
  const body = document.getElementsByTagName('body')[0];

  // get various elements once DOM is ready
  wpAdminBar = document.getElementById('wpadminbar');
  siteHeader = document.getElementById('site-header');
  mobileGeoRestrictionBanner = document.getElementById(
    'geo-restriction-mobile',
  );

  /**
   * Link all telephone anchor tags (on mobile-only)
   */
  if (isMobile) {
    const telephoneLinks = document.querySelectorAll('a[href^="tel:"');
    telephoneLinks.forEach((link) => {
      link.classList.add('clickable');
    });
  }

  /**
   * Display `#site-header-backdrop` when mobile hamburger menu is toggled
   */
  const navbarHamburgerCollapsible = document.getElementById(
    'navbarSupportedContent',
  );
  navbarHamburgerCollapsible.addEventListener('show.bs.collapse', (event) => {
    body.classList.add('navbar-hamburger--expanded');
  });
  navbarHamburgerCollapsible.addEventListener('hide.bs.collapse', (event) => {
    body.classList.remove('navbar-hamburger--expanded');
  });

  /**
   * Display `#site-header-backdrop` when any `.dropdown-menu` is triggered
   */
  const navbarItemsWithDropdowns = document.querySelectorAll(
    '#navbarSupportedContent #menu-main-navigation > li.dropdown',
  );
  if (navbarItemsWithDropdowns) {
    navbarItemsWithDropdowns.forEach((item) => {
      const toggle = item.querySelector('.dropdown-toggle');

      toggle.addEventListener('show.bs.dropdown', (event) => {
        body.classList.add('navbar-dropdown--expanded');
      });
      toggle.addEventListener('hide.bs.dropdown', (event) => {
        body.classList.remove('navbar-dropdown--expanded');
      });
    });
  }

  /**
   * Show intermediary modal (if enabled and has not been accepted in the last 24 hours)
   */
  HcpAttestationModal();

  /**
   * Show external link intemediary modal (if setting is enabled in WP admin)
   */
  ExternalLinkInterstitialModal();

  /**
   * Publications page
   */
  Publications();

  /**
   * Search results page
   */
  SearchResults();

  /**
   * MSL Connect page
   */
  MSLConnect();

  /**
   * Page Search Bar
   */
  PageSearchBar();

  /**
   * Feedback module
   */
  FeedbackModule();

  /**
   * Landing pages
   */
  LandingPages();


  // update CSS variables upon window resize
  const onResize = debounce(() => {
    updateCssVariables();
  }, 500); // Maximum run of once per 500 milliseconds
  window.addEventListener('resize', onResize, false);
});

// Fired once the whole page has loaded, including all dependent resources such as stylesheets, scripts, iframes, and images
window.addEventListener('load', () => {
  // must wait until stylesheets & webfonts are loaded before setting variables
  updateCssVariables();
});
